<template lang="pug">
section(aria-label="Property listing")
  transition-group.grid(name="prop-list", tag="div", :class="{ empty: empty }")
    app-property(
      v-for="property in properties",
      :key="property.FloorplanID",
      :data="property"
    )
  .footer-utility 
    small(v-html="footer")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Theme from "@/listing-app/mixins/Theme";
import Property from "./grid/Property";

export default {
  name: "Grid",
  data() {
    return {
      empty: false,
    };
  },
  mixins: [Theme],
  components: {
    appProperty: Property,
  },
  props: ["data", "footer"],
  computed: {
    ...mapGetters(["read"]),
    properties() {
      let props = [];
      let selected = { ...this.read("filters") };

			//filter through multi selects first
      props = this.data.filter((prop) => {
        let filtered = true;
        Object.keys(selected).forEach((key) => {
          if (Array.isArray(selected[key])) {
            if (selected[key][0].value !== null) {
              filtered = selected[key].some((multi) => prop.Filters[key].includes(multi.value));
            }
          }
        });

        return filtered;
      });

			// then filter through priceMax and other filters
      props = props.filter((prop) => {
        let filtered = true;

        Object.keys(selected).forEach((key) => {
					if (Array.isArray(selected[key])) return;
					
          if (key == "PriceMax") {
            if (prop.MinPrice > parseInt(selected[key].value)) {
              filtered = false;
            }
          } else if (selected[key].value !== null) {
            if (!prop.Filters[key].includes(selected[key].value)) {
              filtered = false;
            }
          }
        });

        return filtered;
      });

      if (props.length) {
        this.empty = false;
      } else {
        this.empty = true;
      }

      this.set({ muta: "totalResults", data: Object.keys(props).length });

      return props;
    },
  },
  methods: {
    ...mapActions(["set"]),
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 40px 0 0;
  margin: 0 -20px;
  position: relative;
  border-top: 1px solid $gray;
  min-height: 551px;
  align-items: stretch;
  &:after {
    content: "Your search parameters returned no results. Please try another search.";
    opacity: 0;
    transform: translateX(10px) translateY(-50%);
    font-size: 22px;
    margin: auto;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 20px;
    right: 20px;
  }
  &.empty {
    &:after {
      transition: all 0.3s 0.3s ease;
      opacity: 1;
      transform: translateX(0) translateY(-50%);
    }
  }
}

.prop-list-enter,
.prop-list-leave-to {
  opacity: 0;
  transform: scale(0, 0);
}

.prop-list-leave-active {
  position: absolute;
}

.footer-utility {
	font-family: HelveticaNeueW02-57Cn;
  font-size: 16px;
  color: $mediumGray;
  line-height: 2.5;
  line-height: 1.75;
  border-top: 1px solid $gray;
  padding: 40px 20px 0;
  margin: 20px -20px 0;
}
</style>
